import React from 'react';
import { Navigate } from 'react-router-dom';

const Ai2ProtectedRoute = ({ children, adminOnly = false }) => {
    const token = localStorage.getItem('token');
    const isAdmin = localStorage.getItem('isAdmin') === '1';
    const isCallCenter = localStorage.getItem('isCallCenter') === '1';

    // Redirect if not logged in
    if (!token) {
        return <Navigate to="/ai2/login" replace />;
    }

    // Redirect if adminOnly route but user is neither admin nor call center
    if (adminOnly && !(isAdmin || isCallCenter)) {
        return <Navigate to="/Ai2/Attendee/Center" replace />;
    }

    return children;
};

export default Ai2ProtectedRoute;
